import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper } from './style';

const Container = ({ children }) => (
	<Wrapper >
		{children}
	</Wrapper>
);

/* Props ================================== */
Container.propTypes = {
	children: PropTypes.node | PropTypes.element,
};

Container.defaultProps = {
	children: null,
};

/* Export ================================== */
export default Container;